import React, { FunctionComponent } from "react";
import { ExternalIcon, ExternalIcons } from "./ExternalIcon";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import "./IconWithBackground.css";

const IconWithBackgroundBase: FunctionComponent<{
  iconSize?: number;
  theme: "client" | "default";
  svgName: ExternalIcons;
  testID?: string;
}> = ({ iconSize = 24, theme, svgName, testID }) => {
  const iconColor =
    theme === "client" ? colors.iconContrast : colors.iconPrimary;
  const backgroundColor =
    theme === "client" ? colors.primary10 : colors.surfaceSecondary;

  return (
    <div
      className="icon-with-background"
      data-testid={`icon-with-background-${testID ?? ""}`}
      style={{
        backgroundColor: backgroundColor,
      }}>
      <ExternalIcon
        size={iconSize}
        color={iconColor}
        testID={testID}
        svgName={svgName}
      />
    </div>
  );
};

const IconWithBackground = React.memo(IconWithBackgroundBase);

export { IconWithBackground };
